/* eslint-disable prettier/prettier */
import { incomeConstants } from "../constants/incomeConstants";
const initialState = {
    data: null,
    status: "idle",
    error: null
}

export const levelIncomeReducer = (state = initialState, action) => {
    switch (action.type) {
        case incomeConstants.FETCHING_LEVEL_INCOME_API_SUCCESS:
            return {
                data: action.payload,
                status: "success",
                error: null
            }
        case incomeConstants.FETCHING_LEVEL_INCOME_API_FAILED:
            return {
                data: null,
                status: "error",
                error: action.payload
            }
        default:
            return state
    }
}
export const rewardIncomeReducer = (state = initialState, action) => {
    switch (action.type) {
        case incomeConstants.FETCHING_REWARD_INCOME_API_SUCCESS:
            return {
                data: action.payload,
                status: "success",
                error: null
            }
        case incomeConstants.FETCHING_REWARD_INCOME_API_FAILED:
            return {
                data: null,
                status: "error",
                error: action.payload
            }
        default:
            return state
    }
}

export const taskIncomeReducer = (state = initialState, action) => {
    switch (action.type) {
        case incomeConstants.FETCHING_TASK_INCOME_API_SUCCESS:
            return {
                data: action.payload,
                status: "success",
                error: null
            }
        case incomeConstants.FETCHING_TASK_INCOME_API_FAILED:
            return {
                data: null,
                status: "error",
                error: action.payload
            }
        default:
            return state
    }
}